import * as React from 'react';
import { cn } from '@/utils/cn';

interface SettingsCardProps {
  children: React.ReactNode;
  className?: string;
}

export const SettingsCard: React.FC<SettingsCardProps> = ({ children, className }) => (
  <div
    className={cn(
      'mb-8 w-full rounded-20 p-6 transition-all',
      'border border-brand-300 bg-transparent',
      className
    )}
  >
    {children}
  </div>
);
